'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ShadowBevel": "Polaris-ShadowBevel"
};

exports.default = styles;
